import { Component, OnInit } from '@angular/core';
import { GlobalConstants } from './../../services/GlobalConstants.service';
import { ConstantsService } from "./../../services/constants.service";
import { BaseService } from "./../../services/base.service";
@Component({
  selector: 'ara-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  isUserLoggedIn = false;
  loggedInUser: any;
  FooterText=GlobalConstants.FooterText;
  constructor( public baseService: BaseService) { }

  ngOnInit(): void {
    const loggedInUser = this.baseService.getItemFromSession(
      ConstantsService.commonConstants.loggedInUser
    );
    this.loggedInUser = JSON.parse(loggedInUser);
    if (loggedInUser) {
      this.isUserLoggedIn = true;
  }

}
}
